// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/myagent." + "hljs" + "." + "b47dba93" + ".chunk.js";
};